import React, { createContext, useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const AppContext = createContext();

async function getDeviceId() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId; // This is your unique device ID
}

const AppProvider = ({ children }) => {
    const [deviceId, setDeviceId] = useState(null); // Store authentication status
    const [auth, setAuth] = useState(null); // Store authentication status
    const [userData, setUserData] = useState(null); // Store user data

    // Load user and auth state, e.g., from local storage or API
    useEffect(() => {
        const storedAuth = localStorage.getItem('auth');
        const storedUserData = localStorage.getItem('userData');
        
        if (storedAuth && storedUserData) {
            setAuth(JSON.parse(storedAuth));
            setUserData(JSON.parse(storedUserData));
        }

        const initDeviceId = async () => {
            const deviceId = await getDeviceId();
            setDeviceId(deviceId);
        }
        initDeviceId();
    }, []);

    // Persist auth and user data changes
    useEffect(() => {
        if (auth) localStorage.setItem('auth', JSON.stringify(auth));
        if (userData) localStorage.setItem('userData', JSON.stringify(userData));
        if (deviceId) localStorage.setItem('deviceId', JSON.stringify(deviceId));
    }, [auth, userData, deviceId]);
    
    return (
        <AppContext.Provider value={{ 
            auth, setAuth, 
            userData, setUserData,
            deviceId, setDeviceId,
        }}>
            {children}
        </AppContext.Provider>
    );
};

export default AppProvider;
